import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SigninView.css';
import AuthButton from '../../buttons/AuthButton';
import TopBar from '../../common/TopBar/TopBar';
import signInImage from '../../../assets/img/img_signin.png';

const SigninView: React.FC = () => {
    const navigate = useNavigate();

    const handleCreateAccount = () => {
        navigate('/signup');
    };

    const handleSignIn = (provider: string) => {
        console.log(`${provider} sign in`);
        if (provider === 'Tiktok') {
            navigate('/hometabs');
        }
    };

    const handleSignInWithEmail = () => {
        navigate('/signin_email');
    };

    const handleForgotPassword = () => {
        navigate('/forgot_password');
    };

    return (
        <div className="signin-view">
            <div className="top-bar-wrapper">
                <TopBar showLogo={true} />
            </div>
            <div className="signin-content">
                <img 
                    src={signInImage}
                    alt="Sign In" 
                    className="signin-image" 
                />
                <h1 className="main-title">Make your passion worth it with us</h1>
                <button className="create-account-button" onClick={handleCreateAccount}>
                    Create account
                </button>
                <div className="auth-buttons">
                    {/* <AuthButton provider="Instagram" action="signin" onSignIn={() => handleSignIn('Instagram')} onSignUp={() => {}} /> */}
                    {/* <AuthButton provider="Tiktok" action="signin" onSignIn={() => handleSignIn('Tiktok')} onSignUp={() => {}} /> */}
                    {/* <AuthButton provider="Apple" action="signin" onSignIn={() => handleSignIn('Apple')} onSignUp={() => {}} /> */}
                    <AuthButton provider="Email" action="signin" onSignIn={handleSignInWithEmail} onSignUp={() => {}} />
                </div>
                <a href="/forgot_password" className="forgot-password" onClick={handleForgotPassword}>Forgot your password?</a>
                <p className="terms">
                    By proceeding, you agree to Pixell's <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
                </p>
            </div>
        </div>
    );
};

export default SigninView;
